import { render, staticRenderFns } from "./ThePageTitle.vue?vue&type=template&id=7b3d8d91&"
import script from "./ThePageTitle.vue?vue&type=script&lang=js&"
export * from "./ThePageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports